import { dispatch } from "./utils";

export class ModalManager {
    public id: string;

    constructor(id: string) {
        if (!id || !id.trim()) {
            throw new Error('ModalManager: id must not be empty');
        }
        this.id = id;
    }

    show() {
        dispatch('show-modal', {
            id: this.id,
        });
    }

    close() {
        dispatch('close-modal', {
            id: this.id,
        });
    }
}

export function ModalManagerFactory(id: string) {
    return new ModalManager(id);
}
